import React, { type FC } from 'react';
import { Space, Text } from '@g2u/ui-kit';

import { type WithOptionalDataTest } from 'types';
import { useText } from 'helpers/hooks/useText';
import { Section } from 'components';

export namespace FinalAssistance {
  export type Props = WithOptionalDataTest;

  export const $: FC<Props> = () => {
    const { getText } = useText();
    return (
      <Section.$ title="Final Assistance and Farewell">
        <Space.$ direction={Space.Direction.Vertical} className='script-box'>
          <Text.$ mark>{getText('booking.confirmation.additionalAssistance')}</Text.$>
          <Text.$ mark>{getText('booking.confirmation.thankYouMessage')}</Text.$>
          <Text.$ size={Text.Size.SM} type="secondary" italic>
            {getText('booking.confirmation.waitBeforeHangingUp')}
          </Text.$>
        </Space.$>
      </Section.$>
    );
  };
}
